export default __webpack_public_path__ + "static/media/people7.b6d520d2.jpeg";